import Admin from './components/Admin/Admin';
import Login from './components/Admin/Account/Login';
import Register from './components/Admin/Account/Register';

import Viewer from './components/Viewer/Viever';
import ViewerLogin from './components/Viewer/Account/Login';
import ViewerRegister from './components/Viewer/Account/Register';
import UserLogin from './components/Viewer/User/UserLogin';
import UserRegister from './components/Viewer/User/UserRegister';
import Profile from './components/Viewer/Account/Profile';
import ViewTrailer from './components/Viewer/ViewTrailer';
import ViewVideo from './components/Viewer/ViewVideo';
import Movies from './components/Viewer/categories/Movies'
import Action from './components/Viewer/categories/Action'
import Drama from './components/Viewer/categories/Drama'
import Comedy from './components/Viewer/categories/Comedy'
import Romance from './components/Viewer/categories/Romance'
import SearchResults from './components/Viewer/SearchResult'

import Home from './pages/Home';
import Missing from './pages/Missing';
import Unauthorised from './pages/Unauthorised';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useToken from './components/Admin/Context/UseToken';

function App () {
  const {  setAccessToken } = useToken();
  return (
    <div>
      <ToastContainer position='top-center' limit={1} />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/admin/*' element={<Admin />} />
        <Route path='/admin' element={<Admin />} />
        <Route path='/admin-login' element={<Login setAccessToken={setAccessToken} />} />
        <Route path='/admin-register' element={<Register />} />
        <Route path='/viewer/*' element={<Viewer />} />
        <Route path='/creator-login' element={<ViewerLogin setAccessToken={setAccessToken}/>} />
        <Route path='/creator/creator-register' element={<ViewerRegister />} />
        <Route path='/user-login' element={<UserLogin setAccessToken={setAccessToken}/>} />
        <Route path='/user/user-register' element={<UserRegister />} />
        <Route path='/viewer/profile' element={<Profile />} />
        <Route path='/viewer/viewtrailer/:id' element={<ViewTrailer />} />
        <Route path='/viewer/viewvideo/:id' element={<ViewVideo />} />
        <Route path='/movies' element={<Movies />} />
        <Route path='/action' element={<Action />} />
        <Route path='/drama' element={<Drama />} />
        <Route path='/comedy' element={<Comedy />} />
        <Route path='/romance' element={<Romance />} />
        <Route path='/search-results' element={<SearchResults />} />
        <Route path='/unauthorised' element={<Unauthorised />} />
        <Route path='*' element={<Missing />} />
      </Routes>
    </div>
  );
}

export default App;
